"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const react_helmet_1 = __importDefault(require("react-helmet"));
const Button_1 = require("@Components/Buttons/Button");
const ModalPortal_1 = __importDefault(require("@App/kit/components/Popups/ModalPortal"));
const PointPreloader_1 = __importDefault(require("@App/kit/components/Preloaders/PointPreloader"));
const contexts_1 = require("@App/contexts");
const matching_1 = require("@App/api/routes/rightsholder/matching");
const ContentHeader_1 = __importDefault(require("@App/kit/components/ContentHeader"));
const SearchWithCriteria_1 = __importDefault(require("@Components/Search/SearchWithCriteria"));
const MatchSearchResults_1 = __importDefault(require("@Scenes/RightsholderScene/MatchClaim/Match/MatchWorkSelection/MatchSearchResults"));
const work_search_store_1 = require("@App/stores/search/work-search-store");
const MatchWorkSelectionHeader_1 = __importDefault(require("@Scenes/RightsholderScene/MatchClaim/Match/MatchWorkSelection/MatchWorkSelectionHeader"));
const SubmitMatchPopup_1 = __importDefault(require("@Components/MatchComponents/SubmitMatchPopup"));
const pluralize_1 = __importDefault(require("pluralize"));
const MatchWorkSelection = (props) => {
    const { catalogSearchStore, rightsholderStore, workSearchStore, matchingStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { goToStep } = props;
    const [modalIsOpen, setModalIsOpen] = (0, react_1.useState)(false);
    const [worksSelection, setWorksSelection] = (0, react_1.useState)('');
    const [resultsData, setResultsData] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [matchWorkSearchCriteriaStore, setMatchWorkSearchCriteriaStore] = (0, react_1.useState)();
    const selectWork = (songCode, title) => {
        setWorksSelection(songCode);
        matchingStore.setSelectedWorkTitle(title);
        setModalIsOpen(true);
    };
    const handleSearch = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (pagination = { page: 1, limit: 5 }) {
        setIsLoading(true);
        yield catalogSearchStore.getWorksRightsHolder(pagination, workSearchStore.matchWorksSelectionSearchQuery);
        setResultsData(catalogSearchStore.worksRightsHolder);
        setIsLoading(false);
    });
    const handleSearchWithNewCriteria = (searchCriteria) => {
        workSearchStore.setMatchWorksSelectionSearchQuery(searchCriteria);
        handleSearch().then();
    };
    const submitMatch = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        yield (0, matching_1.createMatchSuggestion)(rightsholderStore.currentRightsholderId, {
            songCode: worksSelection,
            recordingGroupIds: matchingStore.selectedUnmatchedRecordingGroups,
            hfaPublisherNumber: rightsholderStore.memberSummary.hfaPublisherNumber,
        });
        setIsLoading(false);
        goToStep(3);
    });
    (0, react_1.useEffect)(() => {
        setMatchWorkSearchCriteriaStore(work_search_store_1.WorkSearchStore.createMatchWorkSearchCriteriaStore());
    }, []);
    const numRecGroupsMatching = matchingStore.selectedUnmatchedRecordingGroups.length;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'Matching Tool' }),
        react_1.default.createElement("div", { className: "match-selection-wrapper" },
            react_1.default.createElement("div", { className: 'global-container' },
                react_1.default.createElement(ContentHeader_1.default, { title: 'Match Usage - Select Work', descriptionElement: react_1.default.createElement(MatchWorkSelectionHeader_1.default, null) }),
                react_1.default.createElement("div", { className: "match-work-selection-works" },
                    react_1.default.createElement("p", { className: "instructions" },
                        "Let's search ",
                        react_1.default.createElement("strong", null, "your catalog"),
                        " for a work to match the",
                        react_1.default.createElement("strong", null,
                            " ",
                            (0, pluralize_1.default)('selected recording group', numRecGroupsMatching, true)),
                        " to."),
                    matchWorkSearchCriteriaStore && (react_1.default.createElement(SearchWithCriteria_1.default, { searchCriteriaStore: matchWorkSearchCriteriaStore, canAddCriteria: false, handleSearch: handleSearchWithNewCriteria, orientation: 'row' })),
                    isLoading ? (react_1.default.createElement(PointPreloader_1.default, null)) : resultsData ? (react_1.default.createElement(MatchSearchResults_1.default, { resultsData: resultsData, selectWork: selectWork, handleSearch: handleSearch })) : (react_1.default.createElement("div", { className: "pre-search" },
                        react_1.default.createElement("p", null, "Enter two (2) search criteria to see results")))),
                react_1.default.createElement("div", { className: "bottom-nav" },
                    react_1.default.createElement(Button_1.Button, { mainColor: true, type: "secondary", onClick: () => goToStep(1) }, "Back")),
                react_1.default.createElement(ModalPortal_1.default, { isOpen: modalIsOpen },
                    react_1.default.createElement(SubmitMatchPopup_1.default, { isLoading: isLoading, onCancel: () => setModalIsOpen(false), onConfirm: submitMatch }))))));
};
exports.default = (0, mobx_react_1.observer)(MatchWorkSelection);
